import { EnergyMode } from '@vacationtracker/shared/types/user-insight'

const ENERGY_SUGGESTION_CONTEXT_KEY = 'vt_energy_suggestion_context'

export interface EnergySuggestionFollowThroughContext {
  suggestionIndex: number
  isBestSuggestion: boolean
  startDate: string
  endDate: string
  durationDays: number
  ptoDaysUsed: number
  leaveTypeId: string
  predictedEnergyImprovement: number
  improvementPercentage: number
  confidenceLevel: 'low' | 'medium' | 'high'
  currentEnergyScore: number
  energyMode: EnergyMode
  overlappingUsers: number
  extendedByHolidays: boolean
  totalSuggestionsAvailable: number
  clickTimestamp: string
}

export function setSuggestionContext(context: EnergySuggestionFollowThroughContext): void {
  try {
    sessionStorage.setItem(ENERGY_SUGGESTION_CONTEXT_KEY, JSON.stringify(context))
  } catch { /* never break the user flow */ }
}

export function getSuggestionContext(): EnergySuggestionFollowThroughContext | null {
  try {
    const raw = sessionStorage.getItem(ENERGY_SUGGESTION_CONTEXT_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function clearSuggestionContext(): void {
  try {
    sessionStorage.removeItem(ENERGY_SUGGESTION_CONTEXT_KEY)
  } catch { /* ignore */ }
}
